export default class QrCode {

	constructor() {
		this.id = 0;
		this.PixLink = "";
		this.Emv = "";
		this.ImagemBase64 = "";
	}
}